import React from 'react'
import Covid from './component/api'
import Header from './component/Header'

function App() {
  return (
    <>
      <h1>Gk pattanaik</h1>
      <Header/>
      
      <Covid/>
    </>
  )
}

export default App